import { render, staticRenderFns } from "./AdminHomeAgencyCard.vue?vue&type=template&id=56ac0f5e&scoped=true"
import script from "./AdminHomeAgencyCard.vue?vue&type=script&lang=js"
export * from "./AdminHomeAgencyCard.vue?vue&type=script&lang=js"
import style0 from "./AdminHomeAgencyCard.vue?vue&type=style&index=0&id=56ac0f5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ac0f5e",
  null
  
)

export default component.exports